import React, { useContext, useState, useEffect } from 'react';
import HomePageCtx from './HomePageCtx';
import PublicationCardView from './PublicationCardView';
import { tablePaginationAriaLabels } from '../../../api/UtilsApi';
import {
  Pagination,
  Box,
  PaginationProps,
  NonCancelableCustomEvent,
  StatusIndicator,
} from '@amzn/awsui-components-core';

const NUMBER_OF_PUBLICATION_PER_PAGE = 24;

interface Props {
  readonly isLoadingMore?: boolean;
}

function PublicationCardViewList({ isLoadingMore }: Props) {
  const { filteredPublications, allPublications, searchTerm } = useContext(HomePageCtx);
  const [currentPageIndex, setCurrentPageIndex] = useState(1);

  const renderPublicationList = () => {
    const displayPublications = filteredPublications.slice(
      NUMBER_OF_PUBLICATION_PER_PAGE * (currentPageIndex - 1),
      NUMBER_OF_PUBLICATION_PER_PAGE * currentPageIndex,
    );
    return displayPublications.map((publication) => {
      return <PublicationCardView key={publication.contentId} publication={publication} />;
    });
  };

  const handlePageIndexChange = (event: NonCancelableCustomEvent<PaginationProps.ChangeDetail>) => {
    window.scrollTo({
      behavior: 'smooth',
      top: 0,
    });
    setCurrentPageIndex(event.detail.currentPageIndex);
  };

  const renderMatchedPublicationsNumber = () => {
    if (allPublications.length === filteredPublications.length) {
      return null;
    }
    return (
      <Box color="text-body-secondary">
        {searchTerm ? (
          <>
            {' '}
            for "<span className="home-page-publcation-match-term">{searchTerm}</span>"
          </>
        ) : null}
      </Box>
    );
  };

  useEffect(() => {
    setCurrentPageIndex(1);
  }, [filteredPublications]);

  const pageCount = Math.ceil(filteredPublications.length / NUMBER_OF_PUBLICATION_PER_PAGE);
  return (
    <div>
      {renderMatchedPublicationsNumber()}
      <div className="home-page-publication-list">{renderPublicationList()}</div>
      {/* The page resets each time new content arrives, so offer paging once it all has. */}
      {isLoadingMore ? (
        <Box textAlign="center" padding={{ vertical: 'l' }}>
          <StatusIndicator type="loading">Loading contents...</StatusIndicator>
        </Box>
      ) : (
        <Box float="right">
          <Pagination
            ariaLabels={tablePaginationAriaLabels}
            currentPageIndex={currentPageIndex}
            onChange={handlePageIndexChange}
            pagesCount={pageCount}
          />
        </Box>
      )}
    </div>
  );
}

export default PublicationCardViewList;
